import { Navigate } from "react-router-dom";
import useAuthStore from "@/zustand/authStore";

interface Props {
  children: JSX.Element;
}

const ProtectedAdminRoute = ({ children }: Props) => {
  const user = useAuthStore((state) => state.user);

  // if no user or if user is not an admin, redirect to home
  return user && user.isAdmin ? children : <Navigate to={"/404"} replace />;
};
export default ProtectedAdminRoute;
